<template>
  <div class="backgound">
    <v-container>
      <v-row v-if="screenplay">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <div class="text-center">{{screenplay.id}}</div>
              <v-item-group multiple>
                <v-item class="mb-2" v-slot:default="{}">
                  <v-card
                    class="d-flex pa-3"
                  >
                    <div class="title text--primary" v-text="screenplay.name" />
                  </v-card>
                </v-item>
                <v-item class="mb-2" v-slot:default="{}">
                  <v-card
                    class="d-flex pa-3"
                    min-height="100"
                    max-height="200"
                  >
                    <div class="auto-break auto-scroll w-100" v-text="screenplay.description" />
                  </v-card>
                </v-item>
              </v-item-group>
              <div class="d-flex justify-end">
                <v-btn
                  class="mr-2"
                  v-if="playRecords && playRecords.length > 0"
                  @click="openHistoryPage()"
                >
                  PLAYBACK
                </v-btn>
                <v-btn v-if="actionMode" color="primary" @click="$router.push(`/newgame?sid=${screenplay.id}`)">
                  PLAY
                </v-btn>
                <v-btn v-if="!actionMode" color="primary" @click="$router.push(`/newgame/dev?sid=${screenplay.id}`)">
                  TRIAL
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <simple-prompt ref="prompt"/>
  </div>
</template>

<script>
import _ from 'lodash'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
import Screenplay from '@/lib/Screenplay'
import Message from '@/lib/Message'
import Scene from '@/lib/Scene'
import * as SimplePrompt from '@/components/SimplePrompt'
import axios from '@/lib/axios'

export default {
  name: 'screenplay-editor',
  components: {
    SimplePrompt: SimplePrompt.default
  },
  computed: {
    actionMode(){
      return this.$store.state.actionMode
    },
    user(){
      return this.$store.state.user.profile
    },
    isAuthor(){
      let user = this.$store.state.user.profile
      let authorId = this.screenplay.author
      if(typeof this.screenplay.author === 'object'){
        authorId = this.screenplay.author
      }
      if(this.screenplay && user && user.id === authorId){
        return user
      }
      return false
    },
    author(){
      if(this.isAuthor){
        return this.user
      }
      let author = this.screenplay.author
      if(author){
        if(typeof author === 'object'){
          return this.screenplay.author
        }else if(typeof this.screenplay.author === 'string'){
          this.getAuthorInfo()
          return this.async.author
        }
      }
      return null
    }
  },
  watch: {
  },
  data: ()=>{
    return {
      screenplay: null,
      playRecords: [],
      async: {
        author: null
      }
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.$store.commit('appbar/backTo', `/`)
    })
    this.$nextTick(()=>{
      this.$prompt = this.$refs.prompt.prompt
    })
    util.delay(200)
      .then(()=>gameLoader.loadScreenplay(this.$route.params.sid || 'test'))
      .catch((e)=>{
        return null
      })
      .then((screenplay)=>{
        if(!screenplay){
          // TODO
          throw new Error('screenplay not found')
        }
        this.screenplay = screenplay
        return gameLoader.loadGameRecord({ screenplayId: screenplay.id, withoutData: true })
        // return gameLoader.loadGameRecord({ screenplayId: screenplay.id })
      })
      .then((records)=>{
        this.playRecords = records
      })
  },
  methods: {
    log(){
      console.log.apply(console, arguments)
    },
    async getAuthorInfo(opts = {}){
      // TODO 獲取作者相關訊息的API
      // let info = await axios.get('...............')
      // if(opts.updateAuthor){
      //   this.async.author = info
      //   this.$emit('update-author', info)
      // }
      // return info
      return null
    },
    openHistoryPage(){
      if(this.playRecords && this.playRecords.length > 0){
        let record = this.randomGet(this.playRecords)
        this.$router.push(`/screenplay/history/${record.id}`)
      }
    },
    randomGet(array){
      return array[Math.floor(Math.random() * array.length)]
    }
  }
}
</script>
<style scoped>
  .background{
    width: 100vw;
    max-height: 100%;
    overflow-y: auto;
    background-color: #15202b;
    color: white;
  }
  .w-100{
    width: 100%;
  }
  .auto-break{
    word-wrap: break-word;      /* IE 5.5-7 */
    white-space: -moz-pre-wrap; /* Firefox 1.0-2.0 */
    white-space: pre-wrap;      /* current browsers */
  }
  .auto-scroll{
    overflow-y: auto;
  }
</style>
